const filtersInit = () => {
  const layoutArchive = document.querySelectorAll('.layout--archive') ?? null

  layoutArchive &&
    layoutArchive.forEach((archiveElm) => {
      const radioElm = archiveElm.querySelector('.layout--radio') ?? null

      if (!radioElm) return

      const gridElm = archiveElm.querySelector('.layout--cards') ?? null

      const cardsElm = [...gridElm.children]

      radioElm.addEventListener('change', (e) => {
        gridElm.dataset.topic = e.target.value

        cardsElm.forEach((cardElm) => {
          const topics = cardElm.dataset.topics.split(' ')
          e.target.value === 'all' || topics.includes(e.target.value) ? (cardElm.style.display = '') : (cardElm.style.display = 'none')
        })
      })
    })
}

export default filtersInit
